export default "__VITE_ASSET__BVm8lFsQ__"